
import md5 from 'md5';
import MemorySystem from './subsystems/MemorySystem';
import ErrorSystem from './subsystems/ErrorSystem';
import RestSystem from './subsystems/RestSystem';
import LanguageManagerSystem from './subsystems/LanguageManagerSystem';
import AuthenticationSystem from './subsystems/AuthenticationSystem';
import MerchantManagementSystem from './subsystems/MerchantManagementSystem';
import ShoppingCartSystem from './subsystems/ShoppingCartSystem';
import RfidSystem from './subsystems/RfidSystem';
import QrCodeSystem from './subsystems/QrCodeSystem'; 
import { format } from 'date-fns';

class Framework {
  memorySystem; 
  errorSystem; 
  restSystem;
  languageManagerSystem;
  authenticationSystem;
  rfidSystem; 
  qrCodeSystem;
  merchantManagementSystem;
  shoppingCartSystem;


  
  constructor() {
    this.memorySystem = new MemorySystem(this);
    this.errorSystem = new ErrorSystem(this);
    this.restSystem = new RestSystem(this);
    this.languageManagerSystem = new LanguageManagerSystem(this);
    this.authenticationSystem = new AuthenticationSystem(this);
    this.rfidSystem = new RfidSystem(this);
    this.qrCodeSystem = new QrCodeSystem(this);
    this.merchantManagementSystem = new MerchantManagementSystem(this);
    this.shoppingCartSystem = new ShoppingCartSystem(this);
  }


  getMemorySystem() {
      return this.memorySystem;
  }

  getErrorSystem() {
    return this.errorSystem;
  }

  getRestSystem() {
    return this.restSystem;
  }  

  getLanguageManagerSystem() {
    return this.languageManagerSystem;
  }    
  
  getAuthenticationSystem() {
    return this.authenticationSystem;
  }  
  
  getRfidSystem() {
    return this.rfidSystem;
  }  

  getQrCodeSystem() {
    return this.qrCodeSystem;
  }    

  getMerchantManagementSystem() {
    return this.merchantManagementSystem;
  }

  getShoppingCartSystem() {
    return this.shoppingCartSystem;
  }

  getNexusUrl() {
    if(this.memorySystem !== null) {
      return this.memorySystem.getNexusUrl();  
    }
    return null;
  }  

  getAccessToken() {
    if(this.authenticationSystem !== null) {
      return this.authenticationSystem.getAccessToken();
    }
    return null;
  }

  getUserInfo() {
    if(this.authenticationSystem !== null) {
      return this.authenticationSystem.getUserInfo();
    }
    return null;
  }  

  getEcosystemDeviceData() {
    if(this.authenticationSystem !== null) {
      return this.authenticationSystem.getEcosystemDeviceData();
    }
    return null;
  }

  isUserAuthenticated() {
    if(this.authenticationSystem !== null) {
      return this.authenticationSystem.isUserAuthenticated();
    }
    return false;    
  }

  getMD5(_originalString) {
    return md5(_originalString);
  }

  reformatDateString(_dateString) {
    if(_dateString === undefined) {
      return undefined;
    }
    if(_dateString === null) {
      return null;
    }    
    return this.getFormattedDateString(this.parseDate(_dateString));
  }

  reformatDateTimeString(_dateString) {
    if(_dateString === undefined) {
      return undefined;
    }
    if(_dateString === null) {
      return null;
    }        
    return this.getFormattedDateTimeString(this.parseDateTime(_dateString));       
  }

  parseDate(_dateString) {
    if(_dateString !== null) {      
      return new Date(_dateString);    
    }
    return null;
  }

  parseDateTime(_dateString) {
    if(_dateString !== null) {
      return new Date(_dateString);           
    }
    return null;
  }  

  getJsonFormattedDateTimeString(_date) {
    return this.getFormattedDateTimeString(_date);
  }

  getFormattedDateString(_date) {
    if(_date !== null) {
      return format(_date, 'dd/MM/yyyy');
    }
    return null;
  }  

  getFormattedDateTimeString(_date) {
    if(_date !== null) {
      return format(_date, 'dd/MM/yyyy HH:mm:ss');
    }
    return null;
  }

  getParameterValue(_originalString,_parameterName) {
    if(_originalString !== null) {
      var expresion = /\|\|\|/;
      return this.getParameterValueWithExpresion(_originalString,_parameterName,expresion);
    }
    return null;
  }

  formatNumberString(value){
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }

  getParameterValueWithExpresion(_originalString,_parameterName,_expresion) {
    if(_originalString !== null) {
      var tokenList = _originalString.split(_expresion);    
      for(var i=0; i< tokenList.length; i++) {
        if(tokenList[i] !== null) {
          var fieldList = tokenList[i].split('=');
          if(fieldList.length === 2) {
            if(fieldList[0] === _parameterName) {
              return fieldList[1];
            }
          }
        }         
      }
    }
    return null;
  }

  getText(_languageCode,_textCode) {
    return this.languageManagerSystem.getText(_languageCode,_textCode);
  }

  getDeviceType() {
    return "serviceOrderPos";
  }

  getDeviceId() {
    return "default_device_id";
  }
}


export default Framework;